import type { ModulesEnabledForSwitch, Module } from 'owa-workloads-module';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

const enabledModules: {
    [P in ModulesEnabledForSwitch]: true;
} = {
    Mail: true,
    Calendar: true,
    People: true,
    FilesHub: true,
    AppHost: true,
    Groups: true,
    Tasks: true,
};

export function isModuleEnabledForModuleSwitch(module: Module): boolean {
    // Special case: Tasks module requires PST Tasks feature flag
    if (module === 'Tasks') {
        return isGlobalFeatureEnabled('mon-pst-task');
    }

    return enabledModules[module as ModulesEnabledForSwitch];
}

export function isModuleSwitchEnabled(
    currentModule: Module | undefined,
    newModule: Module
): boolean {
    return (
        (!currentModule || isModuleEnabledForModuleSwitch(currentModule)) &&
        isModuleEnabledForModuleSwitch(newModule)
    );
}
